import { render, staticRenderFns } from "./i-card.vue?vue&type=template&id=b0f1a420&scoped=true"
import script from "./i-card.vue?vue&type=script&lang=js"
export * from "./i-card.vue?vue&type=script&lang=js"
import style0 from "./i-card.vue?vue&type=style&index=0&id=b0f1a420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f1a420",
  null
  
)

export default component.exports